import { usePwaUpdate } from './usePwaUpdate';

/**
 * Update-Hinweis für die angemeldete App.
 *
 * Bewusst eine Leiste im Fluss und KEIN Overlay: Sie schiebt den Inhalt nach
 * unten, statt Bedienelemente zu verdecken. In der angemeldeten App ist ein
 * Update jederzeit zumutbar — schlimmstenfalls lädt eine Liste neu.
 *
 * Auf der Erfassungsseite wird dieser Hinweis NICHT verwendet; dort
 * entscheidet der Zustand des Formulars (siehe CapturePage und ADR-033).
 */
export function UpdateLeiste() {
  const { updateVerfuegbar, anwenden } = usePwaUpdate();
  if (!updateVerfuegbar) return null;

  return (
    <div className="flex flex-wrap items-center justify-between gap-2 bg-brand-700 px-4 py-2 text-sm text-white">
      <span>Eine neue Version von ProofFlow ist verfügbar.</span>
      <button
        type="button"
        onClick={anwenden}
        className="rounded-md bg-white/15 px-3 py-1 font-medium hover:bg-white/25"
      >
        Jetzt aktualisieren
      </button>
    </div>
  );
}
